export default {
  sidebarShow: "responsive",
  sidebarMinimize: false,
  access_token: getSavedState("access_token"),
  refresh_token: getSavedState("refresh_token"),
  userId: getSavedState("userId"),
  type: getSavedState("type"),
};
function getSavedState(key) {
  return JSON.parse(window.localStorage.getItem(key));
}
